import { mountReact } from "../mountReact.jsx";
import CollectionComponent from "../components/CollectionComponent.jsx";
import ProductComponent from "../components/ProductComponent.jsx";
import Returns from "../components/returns/Returns.jsx";

mountReact("#product-section", ProductComponent);
mountReact("#collection-section", CollectionComponent);
mountReact('#returns-section', Returns)
